import styled from 'styled-components';

const Card = styled('div')`
    padding: 6px;
    position: relative;
    z-index: 10;
`;

export default Card;
